import { buildCampusTestNavHref } from "./studentNavPaths";

/**
 * After finishing or leaving a test, return to the course shell (Campus)
 * with the same tab/block/topic context — not the standalone test screen.
 */
export function buildTestCourseReturnPath(pestana, bloque, tema, courseId) {
  const selectedTab = (typeof pestana === "string" ? pestana.trim() : "") || "Test";
  const selectedBlock = (typeof bloque === "string" ? bloque.trim() : "") || "Test";
  const selectedTopic = (typeof tema === "string" ? tema.trim() : "") || "Test";
  const basePath = buildCampusTestNavHref(selectedTab, selectedBlock, selectedTopic);
  const selectedCourseId = typeof courseId === "string" ? courseId.trim() : "";
  if (!selectedCourseId) {
    return basePath;
  }
  const separator = basePath.includes("?") ? "&" : "?";
  return `${basePath}${separator}curso=${encodeURIComponent(selectedCourseId)}`;
}
